import React from "react"
import { Box, Chip } from "@material-ui/core"
import { colors } from "@/styles/colors"
import { Person as PersonIcon } from "@material-ui/icons"
import ColorUtil from "@/utils/ColorUtil"

type UseMessageBlastUserInfoChipProps = {
	createdByUser?: {
		id?: number
		name?: string
	}
	executedByUser?: {
		id?: number
		name?: string
	}
}

export const useMessageBlastUserInfoChip = ({ executedByUser, createdByUser }: UseMessageBlastUserInfoChipProps) => {
	const renderMessageBlastUserInfoChip = () => {
		if (executedByUser?.id) {
			return (
				<Box display="flex" alignItems="center">
					<Chip
						icon={<PersonIcon style={{ marginLeft: "10px" }} htmlColor={colors.blue[600]} />}
						label={`Envio realizado por: ${executedByUser.name}`}
						style={{ ...ColorUtil.getBackgroundAndContrastColor(colors.blue[100]) }}
					/>
				</Box>
			)
		}

		if (createdByUser?.id) {
			return (
				<Box display="flex" alignItems="center">
					<Chip
						icon={<PersonIcon style={{ marginLeft: "10px" }} htmlColor={colors.blue[600]} />}
						label={`Criado por: ${createdByUser.name}`}
						style={{ ...ColorUtil.getBackgroundAndContrastColor(colors.blue[100]) }}
					/>
				</Box>
			)
		}

		return null
	}

	return { renderMessageBlastUserInfoChip }
}
